import { routes as coreRoutes } from 'Core/routes';
import { routes as depositRoutes } from 'Modules/deposit/routes';
import { routes as directSalesRoutes } from 'Modules/directSales/routes';
import { routes as creditDebitRoutes } from 'Modules/creditDebit/routes';
import { routes as cardPaymentRoutes } from 'Modules/cardPayment/routes';
import { routes as financingRoutes } from 'Modules/financing/routes';
import { routes as patientfiRoutes } from 'Modules/patientfi/routes';
import { routes as fortivaRoutes } from 'Modules/fortiva/routes';
import { routes as lendFlowRoutes } from 'Modules/lendFlow/routes';

export const routes = {
  us: [
    ...coreRoutes,
    ...depositRoutes,
    ...directSalesRoutes,
    ...creditDebitRoutes,
    ...cardPaymentRoutes,
    ...financingRoutes,
    ...patientfiRoutes,
    ...fortivaRoutes,
    ...lendFlowRoutes,
  ],
  ca: [...coreRoutes, ...depositRoutes],
};
